<template>
  <three-step-history
    api="home-bill-delete-request"
    :columns="columns"
    done-word="ລຶບແລ້ວ"
    search-label="ຊື່, ເບີໂທ, CUS_, ເລກບິນ"
  />
</template>

<script>
import ThreeStepHistory from '@/views/threeStep/ThreeStepHistory.vue';

export default {
  name: 'HomeBillDeleteHistory',
  components: { ThreeStepHistory },
  title() {
    return 'Vientiane Waste Co-Dev|Home Bill Delete History';
  },
  data() {
    return {
      columns: [
        { text: 'ບິນ', value: 'bill_number' },
        { text: 'ລູກຄ້າ', value: 'customer_name' },
        { text: 'ຍອດເງິນ', value: 'total', align: 'end' },
        { text: 'ສະຖານະບິນກ່ອນລຶບ', value: 'bill_status' },
      ],
    };
  },
};
</script>
